import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from "react";
import classNames from "classnames";
import { TabSelector } from "./TabSelector/TabSelector";
import styles from "./Tabs.module.scss";
export const Tabs = ({ defaultTabIndex = 0, onTabClick, children, tabsWrapperClassName, tabMenuClassName, tabContentClassName, }) => {
    const childrenArray = useMemo(() => (Array.isArray(children) ? children : [children]), [children]);
    if (defaultTabIndex >= childrenArray.length) {
        console.warn(`defaultTabIndex (${defaultTabIndex}) is greater than number of tabs (${childrenArray.length})`);
    }
    const everyChildIsDisabled = childrenArray.every(({ props }) => props.disabled);
    if (everyChildIsDisabled) {
        console.warn("All tabs are disabled, please enable at least one tab");
    }
    // defaultTab isn't pointing to a disabled tab
    const firstEnabledTabIndex = childrenArray.findIndex(({ props }) => !props.disabled);
    const safeDefaultTabIndex = childrenArray[defaultTabIndex]?.props.disabled ? firstEnabledTabIndex : defaultTabIndex;
    const [activeTabIndex, setActiveTabIndex] = useState(safeDefaultTabIndex);
    const changeTab = useCallback((newIndex) => {
        if (childrenArray[newIndex]?.props.disabled)
            return;
        onTabClick?.(newIndex);
        setActiveTabIndex(newIndex);
    }, [childrenArray, onTabClick]);
    return (_jsxs("div", { className: classNames(styles.wrapper, tabsWrapperClassName), children: [_jsx("div", { className: classNames(styles.tabMenu, tabMenuClassName), children: childrenArray.map(({ props }, index) => {
                    const isDisabled = props.disabled;
                    const isActive = activeTabIndex === index;
                    return (_jsx(TabSelector, { onClick: () => changeTab(index), active: isActive, disabled: isDisabled, role: "tab", "aria-selected": isActive, "aria-controls": `tabContent-${index}`, children: props.label }, `tabLabel-${index}`));
                }) }), _jsx("div", { className: classNames(styles.tabView, tabContentClassName), children: childrenArray[activeTabIndex] })] }));
};
//# sourceMappingURL=Tabs.js.map